import React from 'react'
import { Box, Typography, Grid } from '@mui/material'
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined'
import BuildOutlined from '@mui/icons-material/BuildOutlined'
import AccessTimeOutlined from '@mui/icons-material/AccessTimeOutlined'
import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined'

const reasons = [
  {
    icon: <HandshakeOutlined fontSize="large" sx={{ color: '#8FAA30' }} />,
    title: 'Customer-Centered Approach',
    description: 'Your satisfaction is our priority. We listen to your needs and tailor our services to ensure you receive the best possible solution.',
  },
  {
    icon: <BuildOutlined fontSize="large" sx={{ color: '#8FAA30' }} />,
    title: 'Innovative Design Solutions',
    description: 'We bring creativity and innovation to every project. Our team stays up-to-date with the latest trends and techniques.',
  },
  {
    icon: <AccessTimeOutlined fontSize="large" sx={{ color: '#8FAA30' }} />,
    title: 'Timely Service',
    description: 'We respect your time and complete every project on schedule.',
  },
  {
    icon: <VerifiedOutlined fontSize="large" sx={{ color: '#8FAA30' }} />,
    title: 'Trusted & Reliable',
    description: 'Our reputation is built on reliability, trust, and consistent quality.',
  },
]

const WhyChooseUs = () => (
  <Box
    sx={{
      px: { xs: 4, md: 8 },
      py: 6,
      textAlign: 'center',
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        color: '#f5f7f6',
        mb: 4,
      }}
    >
      Why Choose Us?
    </Typography>

    <Grid container spacing={4} justifyContent="center">
      {reasons.map((reason, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Box display="flex" flexDirection="column" alignItems="center">
            {reason.icon}

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mt: 2,
                color: '#ffffff',
              }}
            >
              {reason.title}
            </Typography>

            <Box
              sx={{
                borderBottom: 3,
                borderColor: '#8FAA30',
                width: '120px',
                my: 1,
              }}
            />

            <Typography
              variant="body2"
              sx={{
                color: '#d7e3dd',
                lineHeight: 1.6,
              }}
            >
              {reason.description}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
)

export default WhyChooseUs
